export const MENU_EMOJIS = [
  '⭐️',
  '😃',
  '😁',
  '😄',
  '😊',
  '😉',
  '😍',
  '🥰',
  '😗',
  '😋',
  '😛',
  '😝',
  '😜',
  '🤠',
  '🤗',
  '🤩',
  '🤤',
  '🫶',
  '🫰🏻',
  '❤️',
  '🎉',
  '🍀',
  '💞',
  '❣️',
  '💌',
  '💟',
  '😹',
  '😸',
  '😺',
  '😻',
  '😽',
  '🐵',
  '🐶',
  '🦁',
  '🐯',
  '🦒',
  '🦊',
  '🦝',
  '🐰',
  '🐹',
  '🐭',
  '🐗',
  '🐷',
  '🐮',
  '🐻',
  '🐻‍❄️',
  '🐨',
  '🐼',
  '🐸',
  '🐴',
  '🫎',
  '🫏',
  '🦄',
  '🐔',
  '🐲',
  '🐽',
  '🐒',
  '🦍',
  '🦮',
  '🐕',
  '🐏',
  '🦘',
  '🐪',
  '🐐',
  '🦥',
  '🦣',
  '🐘',
  '🦨',
  '🦡',
  '🦔',
  '🐇',
  '🐿️',
  '🦎',
  '🐊',
  '🐢',
  '🐍',
  '🐬',
  '🦈',
  '🦭',
  '🐳',
  '🐟',
  '🐠',
  '🐡',
  '🦐',
  '🦑',
  '🐙',
  '🦀',
  '🦞',
  '🐓',
  '🦆',
  '🐚',
  '🐌',
  '🐤',
  '🦉',
  '🐦‍🔥',
  '🐣',
  '🚑',
  '🚒',
  '🚗',
  '🚌',
  '🚎',
  '🚓',
  '🏍',
  '✈️',
  '🚀',
  '🛸',
  '🛰',
  '🚁',
  '🚤',
  '🚢',
  '⚓️',
  '⚽️',
  '🏀',
  '🏈',
  '⚾️',
  '🏐',
  '🏸',
  '🏓',
  '🪀',
  '🥇',
  '🏆',
  '🏘',
  '🏭',
  '🏢',
  '🏬',
  '🏣',
  '🏥',
  '🏦',
  '🏨',
  '🏪',
  '⌚️',
  '📱',
  '📷',
  '🎥',
  '🧭',
  '🕰',
  '🍀',
  '🍄',
  '🌾',
  '💐',
  '🌷',
  '🪷',
  '🌸',
  '🪻',
  '🎍',
  '🌼',
  '🌻',
  '🌞',
  '🌝',
  '🌜',
  '🌚',
  '🌕',
  '🌖',
  '🌗',
  '🌘',
  '🌑',
  '🌒',
  '🌓',
  '🌔',
  '🌙',
  '🌎',
  '🪐',
  '💫',
  '🌟',
  '✨',
  '⚡️',
  '☄️',
  '💥',
  '🔥',
  '🌪',
  '🌈',
  '☀️',
  '🌤',
  '☁️',
  '🌦',
  '🌧',
  '⛈',
  '🌩',
  '🌨',
  '❄️',
  '☃️',
  '💧',
  '💦',
  '🫧',
  '☔️',
  '🌊',
  '🍏',
  '🍐',
  '🍊',
  '🍋',
  '🍋‍🟩',
  '🍌',
  '🍉',
  '🍇',
  '🍓',
  '🫐',
  '🍈',
  '🍒',
  '🍑',
  '🥭',
  '🍍',
  '🥥',
  '🥝',
  '🍅',
  '🥑',
  '🥦',
  '🫛',
  '🥬',
  '🫜',
  '🥒',
  '🫑',
  '🌽',
  '🥕',
  '🥐',
  '🥯',
  '🍞',
  '🥖',
  '🥨',
  '🧀',
  '🥚',
  '🍳',
  '🧈',
  '🥞',
  '🧇',
  '🥓',
  '🥩',
  '🍗',
  '🍖',
  '🦴',
  '🌭',
  '🍔',
  '🍟',
  '🍕',
  '🫓',
  '🥪',
  '🥙',
  '🧆',
  '🌮',
  '🌯',
  '🫔',
  '🥗',
  '🥘',
  '🫕',
  '🥫',
  '🍝',
  '🍜',
  '🍲',
  '🍛',
  '🍣',
  '🍱',
  '🥟',
  '🦪',
  '🍤',
  '🍙',
  '🍚',
  '🍘',
  '🍥',
  '🥠',
  '🥮',
  '🍢',
  '🍡',
  '🍧',
  '🍨',
  '🍦',
  '🥧',
  '🧁',
  '🍰',
  '🎂',
  '🍮',
  '🍭',
  '🍬',
  '🍫',
  '🍿',
  '🍩',
  '🍪',
  '🌰',
  '🥜',
];

export const EMOJI_COUNT = MENU_EMOJIS.length;
